import { CABINET_BASE_URL } from "@/config/const";
import apiService from "../api.service";
import { AuthParams } from "./types";

export default {
  login() {
    return apiService.get(`${CABINET_BASE_URL}login`);
  },
  auth(p: AuthParams) {
    return apiService.get(`${CABINET_BASE_URL}rest/user/auth`, {
      params: p,
    });
  },
  logout() {
    return apiService.get(`${CABINET_BASE_URL}rest/user/logout`);
  },
  async getRoles() {
    return (await apiService.get(`${CABINET_BASE_URL}rest/user/roles`)).data;
  },
  async getEmployerStatus() {
    return (await apiService.get(`${CABINET_BASE_URL}rest/employer/status`))
      .data;
  },
};
